let I18n = null

export function t(key) {
  if (!I18n) {
    const script = document.getElementById("alert-messages-translations")
    if (script) {
      try {
        I18n = JSON.parse(script.textContent)
      } catch (error) {
        I18n = {}
      }
    } else {
      I18n = {}
    }
  }
  return I18n[key] || key
}
